var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.edit.isLoading)?_c('BaseLoading'):_c('ProductLabelEditForm',{on:{"submit":_vm.handleSubmit},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []

export { render, staticRenderFns }